import React from 'react';
import TrainingCard from '../../../../../components/TrainingCard/TrainingCard';
import './MyTrainings.scss';

export default function MyTrainings({ userTrainings }) {

    return (
        <section className="account-page_my-trainings">
            <h3>Mes formations</h3>
            <ul className="account-page_my-trainings__trainings-list">
                {
                    userTrainings?.length === 0 ?
                        <p className="account-page_my-trainings__no-trainings">
                            Vous n'avez pas encore de formation
                        </p>
                    :
                        userTrainings?.length > 0 ?
                            userTrainings.map(training => (

                                <li key={training.id}>
                                    <TrainingCard training={training} />
                                </li>

                            ))
                        :
                            <>
                                {Array.from({ length: userTrainings?.length }).map((_, index) => (
                                    <li key={'skeleton' + index}>
                                        <TrainingCard
                                            training={{
                                                title: '',
                                                goal: '',
                                                chaptersCount: '',
                                                lessonsCount: '',
                                            }}
                                            isSkeleton={true}
                                        />
                                    </li>
                                ))}
                            </>
                }
            </ul>
        </section>
    )
}
